<div class="_card-v2-card">
  <!-- TOP SECTION -->
  <div class="_card-v2-card-top-section" (click)="rowClickEmit()">
    <div class="_card-v2-avatar">
      @for (profile of profileData; track profile) {
        <div>
          @if (!imageURL && profile.image == true && profile.valid) {
            <img class="_card-v2-avatar"
              src="./assets/images/{{profile.image_name}}" width="85">
            }
            @if (imageURL && profile.image == true && profile.valid) {
              <img class="_card-v2-avatar"
                [src]="imageURL | secure  | async" width="85">
            }
          </div>
        }
        @for (profile of profileData; track profile) {
          @if (!profile.image && profile.valid) {
            <p class="{{profile.class_name}}">{{getValue(item, field)}}
            </p>
          }
        }
      </div>
      <div class="_card-v2-top-details">
        <div class="_card-v2-name-row">
          @for (field of headerResource; track field; let i = $index) {
            <span class="_card-v2-patient-name">
              @if (field.valid && !field.hasOwnProperty('grid_color_text')) {
                {{getValue(item, field)}}
              }
              @if (field.text_color) {
                <span class="status" [ngClass]="(field.grid_color_text!=undefined && field.grid_color_text) || (field.name == 'priority' || field.name== 'priority_name' || field.name == 'servicePriority') ? getClass(item, field) : ''">
                  {{getValue(item, field)}}
                </span>
              }
            </span>
          }
        </div>
        <div class="_card-v2-info-row">
          @for (field of SubHeader; track field; let i = $index) {
            @if (field.valid && field.type !== 'icon_pic' && !field.hasOwnProperty('grid_color_text')) {
              <span [class.uhid-value-highlight]="field.name === 'uhId'">{{getValue(item, field)}}</span> @if (i!=headerResource.length-1) {
              <span
                >
              |</span>
            }
          }
          @if (field.valid && field.type === 'icon_pic') {
            <span class="_card-v2-status-icons">
              <ng-container [ngTemplateOutlet]="dataRendererCARD"
              [ngTemplateOutletContext]="{field:field, item: item,index:iRow}"></ng-container>
            </span>
          }
          @if (field.text_color) {
            <span class="status"
              [ngClass]="(field.grid_color_text!=undefined && field.grid_color_text) || (field.name == 'priority' || field.name== 'priority_name' || field.name == 'servicePriority') ? getClass(item, field) : ''">
              {{getValue(item, field)}}
            </span>
          }
        }

      </div>
    </div>
  </div>


  <!-- BOTTOM SECTION -->
  <div class="_card-v2-card-bottom-section" (click)="rowClickEmit()">
    <!-- {{bodyResource|json}} -->
    @for (field of bodyResource; track field; let i = $index; let iRow = $index) {
      <!-- {{field|json}} -->
      @if (field.section=='top') {
        <div>
          @if (field.icon) {
            <i class="fa" [ngClass]="field.icon?field.icon:''" aria-hidden="true"></i>
          }
          <ng-container [ngTemplateOutlet]="dataRendererCARD"
            [ngTemplateOutletContext]="{field:field, item: item,index:iRow}">
          </ng-container>
        </div>
      }
      @if (field.section=='middle') {
        <div>
          @if (field.icon) {
            <i class="fa" [ngClass]="field.icon?field.icon:''" aria-hidden="true"></i>
          }
          @if (field.heading) {
            {{field.heading|translate|async}} :
          }
          <ng-container [ngTemplateOutlet]="dataRendererCARD"
            [ngTemplateOutletContext]="{field:field, item: item,index:iRow}">
          </ng-container>
          @if (i!=bodyResource.length-1) {
          }
        </div>
      }
      @if (field.section=='bottom') {
        <div>
          @if (field.heading) {
            {{field.heading|translate|async}} :
          }
          <ng-container [ngTemplateOutlet]="dataRendererCARD"
            [ngTemplateOutletContext]="{field:field, item: item,index:iRow}">
          </ng-container>
          @if (i!=bodyResource.length-1) {
          }
        </div>
      }
    }

    <ng-template #dataRendererCARD let-item='item' let-field="field" let-index="index">
      @if (field.type !== 'date' && field.type !== 'datetime' && field.type !== 'time' && field.type !== 'HashMap' && field.type !== 'icon_pic') {
        <span
          >
          {{ getValue(item, field) }}
        </span>
      }

      @if (field.type == 'date') {
        <span style="display:inline; margin-right:6px;">
          {{ item[field.name] | dateFormat }}
        </span>
      }

      @if (field.type == 'datetime') {
        <span style="display:inline; margin-right:6px;">
          {{ item[field.name] | dateTimeFormat }}
        </span>
      }

      @if (field.type == 'time') {
        <span style="display:inline; margin-right:6px;">
          {{ item[field.name] | timeFormat }}
        </span>
      }

      @if (field.type === 'HashMap' && item['tag_data']!=undefined && item['tag_data'].length!=undefined) {
        <span>
          <!-- {{ getValue(item, field)}} -->
          @for (key of item['tag_data']; track key) {
            @if (key.visible) {
              {{key.key_name}}&nbsp;:&nbsp;{{key.key_value_display}}
            }
          }
        </span>
      }

      @if (field.type === 'icon_pic') {
        <span>
          @for (image of field.image_conditions; track image) {
            <ng-template #image_popover_data>
              <span>{{image.popover_data | translate |async}}</span>
            </ng-template>
            @if (checkBannerExpression(image.expression,item)) {
              <img [popover]="field.show_popover?image_popover_data:''" class="Imageconditionflag" placement="bottom"
                container="body" triggers="mouseenter:mouseleave"
                src="assets/images/{{image.path}}">
              }
            }
          </span>
        }
      <!-- </div> -->
    </ng-template>
  </div>

  <div class="_card-v2-card-footer-section">
    @if (statusResource && statusResource.length) {
      <div class="_card-v2-card-footer-left" (click)="rowClickEmit()">
        @for (field of statusResource; track field; let iRow = $index) {
          <div class="_card-v2-card-footer-action">
            @if (field.valid) {
              <span class="status"
                [ngClass]="(field.grid_color_text!=undefined && field.grid_color_text) || (field.name == 'priority' || field.name== 'priority_name' || field.name == 'servicePriority') ? getClass(item, field) : ''">
              <i class="fa fa-circle" aria-hidden="true"></i>
            </span>
            <span class="status-text">
              <ng-container [ngTemplateOutlet]="dataRendererCARD"
                [ngTemplateOutletContext]="{field:field, item: item,index:iRow}">
              </ng-container>
            </span>
          }
        </div>
      }
    </div>
  }
  @if (buttonResource) {
    <div class="_card-v2-card-footer-right">
      @for (button of buttonResource; track button) {
        @if (button.valid && checkConditionactionname(button) == true) {
          <div
            class="_card-v2-card-footer-action cursor-pointer" (click)="buttonAction(button,item)">
            <span class="status"><i class="fa fa-location-arrow" aria-hidden="true"></i></span>
            <span class="status-text">{{button.text |translate | async}}</span>
          </div>
        }
      }
    </div>
  }
</div>

</div>